<ng-container *ngIf="order$ | async as cart">
  <div class="bonus-container" *ngIf="cart?.bonus?.assignedAmountInfo">
    <div class="cx-summary-row cx-summary-bonus">
      <div class="cx-summary-label-bonus">Начислено баллов:</div>
      <div class="cx-summary-amount-bonus">
        <sd-bonus-widget [amount]="cart?.bonus?.assignedAmountInfo?.formattedValue"></sd-bonus-widget>
      </div>
    </div>
  </div>
</ng-container>
